var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fm-poper-select',_vm._b({staticClass:"user-select",attrs:{"options":_vm.options},on:{"change":_vm.onChange}},'fm-poper-select',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }